import { User, getAuthenticatedUser } from '../AuthenticationService';
import { ConsentCategory } from '../ConsentService';

import { ZendeskApi, ZendeskSettings } from './types';
import { hasZendeskApiInitialized, hasZendeskSettingsConfigured } from './utils';

let initializationPromise: Promise<ZendeskApi> | null = null;

export const defaultZendeskSettings: ZendeskSettings = {
  webWidget: {
    navigation: {
      popoutButton: { enabled: false },
    },
    color: {
      theme: '#00b2b2',
    },
    contactForm: {
      suppress: true,
      subject: true,
    },
    chat: {
      suppress: true,
    },
    helpCenter: {
      suppress: true,
    },
    answerBot: {
      suppress: true,
    },
  },
};

export async function initializeZendeskApi() {
  if (initializationPromise) {
    return initializationPromise;
  }

  initializationPromise = new Promise((resolve) => {
    if (hasZendeskApiInitialized(window)) {
      resolve(window.zE);
    }

    if (!hasZendeskSettingsConfigured(window)) {
      window.zESettings = defaultZendeskSettings;
    }

    const script = document.createElement('script');

    script.setAttribute('type', 'text/javascript');
    script.setAttribute('id', 'ze-snippet');
    script.setAttribute('src', `https://static.zdassets.com/ekr/snippet.js?key=${environment.ZENDESK_API_KEY}`);

    script.addEventListener('load', () => {
      if (hasZendeskApiInitialized(window)) {
        window.zE('webWidget', 'setLocale', getAuthenticatedUser(User.Preferences).language.split('-')[0]);
        window.zE('webWidget', 'hide');
        window.zE('webWidget:on', 'close', () => {
          if (hasZendeskApiInitialized(window)) {
            window.zE('webWidget', 'hide');
            window.zE('webWidget', 'updateSettings', defaultZendeskSettings);
          }
        });

        const { firstName, lastName, email } = window.__INITIAL_STATE__.user;
        window.zE('webWidget', 'identify', {
          name: [firstName, lastName].join(' '),
          email: email,
        });

        resolve(window.zE);
      }
    });

    script.dataset.cookieconsent = ConsentCategory.Necessary;
    document.head.appendChild(script);
  });

  return initializationPromise;
}
